<div class="accordion" id="accordionExample">
  <div class="card">
      <div class="card-header panel-heading" id="headingOne">
          <h5 class="mb-0"><button aria-controls="collapseOne" aria-expanded="true" class="btn btn-link" data-target="#collapseOne" data-toggle="collapse" type="button"><span class="title"><i class="icon icon-set"></i><span style="padding-right: 10px;">SET</span><span>mai</span><span>TFEX</span></span><span
          class="icon-collapse icon-collapse-close"><i class="fas fa-chevron-up"></i></span></button></h5>
      </div>
      <div aria-labelledby="headingOne" class="collapse panel-collapse show" data-parent="#accordionExample" id="collapseOne">
          <div class="card-body">
              <section class="block-center my-auto" style="text-align: center"><iframe frameborder="0" height="206" scrolling="no" src="https://weblink.settrade.com/banner/banner3.jsp" width="200"></iframe></section>
          </div>
      </div>
  </div>
  <div class="card">
      <div class="card-header panel-heading" id="headingTwo">
          <h5 class="mb-0"><button aria-controls="collapseTwo" aria-expanded="false" class="btn btn-link collapsed" data-target="#collapseTwo" data-toggle="collapse" type="button"><span class="title"><i class="icon icon-dex"></i><span>ThaiDEX</span></span><span
          class="icon-collapse icon-collapse-close"><i class="fas fa-chevron-up"></i></span></button></h5>
      </div>
      <div aria-labelledby="headingTwo" class="collapse panel-collapse" data-parent="#accordionExample" id="collapseTwo">
          <div class="card-body iiv">
              <section class="block-center my-auto">
                  <div class="head-table-dex"><span class="logo"><img alt="logo dex" class="img-responsive" src="../../../assets/images/logo/logo-dex@2x.png"></span><span class="time">{{date}} {{time}}</span></div>
                  <table class="table table--dex">
                      <thead>
                          <tr>
                              <th style="border-radius: 20px 0 0 20px;">Fund</th>
                              <th>IIV</th>
                              <th>Chg.</th>
                              <th>%Chg.</th>
                              <th style="border-radius: 0 20px 20px 0;">T.E.</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr *ngFor="let item of collapseIIV">
                              <td><strong>{{item.PortfolioCode}}</strong></td>
                              <td><span class="yellow">{{item.IIV}}</span></td>
                              <td class="hasCaret">
                                  <span class="{{isPositive(item.NAVChange) ? 'up' : 'down'}}">
                  <i class="fas fa-caret-{{caretStatus}}"></i>
                  <span>{{showOnlyValue(item.NAVChange)}}</span>
                                  </span>
                              </td>
                              <td> <span class="{{isCheckcolor(item.PercentChange)}}">{{item.PercentChange}}%</span></td>
                              <td>{{item.TrackingError}}%</td>
                          </tr>
                      </tbody>
                  </table>
              </section>
          </div>
      </div>
  </div>

  <div class="card">
      <div class="card-header panel-heading" id="headingThree">
          <h5 class="mb-0"><button aria-controls="collapseThree" aria-expanded="false" class="btn btn-link collapsed" data-target="#collapseThree" data-toggle="collapse" type="button"><span class="title"><i class="icon icon-oil"></i><span>Oil
            Price</span></span><span class="icon-collapse icon-collapse-close"><i class="fas fa-chevron-up"></i></span></button></h5>
      </div>
      <div aria-labelledby="headingThree" class="collapse panel-collapse" data-parent="#accordionExample" id="collapseThree">
          <div class="card-body">
              <section id="oil">
                  <noscript> To get the BRENT <a href="http://www.oil-price.net/dashboard.php?lang=en#brent_crude_price_large">oil
            price</a>, please enable Javascript.</noscript>
              </section>
          </div>
      </div>
  </div>

  <div class="card">
      <div class="card-header panel-heading" id="headingFour">
          <h5 class="mb-0"><button aria-controls="collapseFour" aria-expanded="false" class="btn btn-link collapsed" data-target="#collapseFour" data-toggle="collapse" type="button"><span class="title"><i class="icon icon-gold"></i><span>Gold
            Price</span></span><span class="icon-collapse icon-collapse-close"><i class="fas fa-chevron-up"></i></span></button></h5>
      </div>
      <div aria-labelledby="headingFour" class="collapse panel-collapse" data-parent="#accordionExample" id="collapseFour">
          <div class="card-body">
              <section id="gold">
                  <noscript> To get the <a href="http://www.gold-quote.net">gold price</a>, please enable Javascript.
        </noscript>
              </section>
          </div>
      </div>
  </div>
  <div class="card">
      <div class="card-header panel-heading" id="headingFive" style="border-radius: 0 0 20px 20px;">
          <h5 class="mb-0"><button class="btn btn-link collapsed" type="button" (click)="linkStoxx()"><span class="title"><i
            class="icon icon-stox"></i><span>STOXXASEAN30</span></span></button></h5>
      </div>
  </div>
</div>
